import herosection from '../../assets/images/herosection.jpg';
import herosectionWebP from '../../assets/images/herosection.webp';
import herosectionSmall from '../../assets/images/herosection_low.webp';
import { useBlurredImageLoader } from '../../utils/useBlurredImageLoader';

const HeroSection = () => {
    const { containerRefs, imgRefs } = useBlurredImageLoader(2);
    const [desktopContainerRef, mobileContainerRef] = containerRefs;
    const [desktopImgRef, mobileImgRef] = imgRefs;

    return (
        <>
        {/* Tablet & Larger view */}
        <div className="hidden sm:block relative w-full sm:min-h-[600px] lg:min-h-[700px] overflow-hidden mb-[100px]">
        {/* Background Image with modern formats */}
        <div 
          ref={desktopContainerRef}
          className="blurred-img absolute inset-0 w-full h-full"
          style={{ backgroundImage: `url(${herosectionSmall})` }}
        >
          <picture>
            <source srcSet={herosectionWebP} type="image/webp" />
            <img
              ref={desktopImgRef}
              src={herosection}
              alt="Hero"
              className="w-full h-full object-cover object-top"
              loading="eager"
              fetchpriority="high"
              decoding="async"
            />
          </picture>
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-transparent w-2/3 z-1"></div>

        <div className="absolute inset-0 pl-[100px] py-16 lg:py-32 max-w-7xl mx-auto flex flex-col items-start justify-center font-poppins text-[#248493] z-2">
          <div className="max-w-lg lg:max-w-2xl">
            <h1 className="text-4xl lg:text-[42px] xl:text-[70px] font-bold leading-tight mb-8">
              Our Services
            </h1>
            <p className="text-lg lg:text-xl xl:text-2xl leading-relaxed font-medium">
              At Roselea Care Homes, life is about more than just care it’s a
              warm and nurturing environment...
            </p>
          </div>
        </div>
      </div> 

        {/* Mobile view */}
        <section className='sm:hidden px-[20px]'>
            <div className="text-[#248493] mt-[35px] font-poppins">
                <h1 className='text-[28px] font-bold mb-[20px]'> Our Services </h1>
                <p className='text-sm font-medium'> At Roselea Care Homes, Life Is About More Than Just Care—It's the Environment…</p>
            </div>
            <div 
              ref={mobileContainerRef}
              className='blurred-img relative w-full h-[202px] overflow-hidden rounded-md mt-[45px]'
              style={{ backgroundImage: `url(${herosectionSmall})` }}
            >
              <img 
                ref={mobileImgRef}
                src={herosection} 
                alt='backgroundImage' 
                className='absolute top-[40px] left-[-70px] object-cover object-right-top scale-150'
                loading="lazy"
                decoding="async"
              />
            </div>
        </section>
        </>
    );
};

export default HeroSection;